import { CUR_LANG } from "../lib/urls";

const T = {
  en: { vrt: "VANROCK rubber track", width: "width (mm)", pitch: "pitch (mm)", links: "number of links", narrow: "narrow guide variant", wide: "wide guide variant", variant: "design variant", bobcat: "Bobcat-style OEM track design", yanmar: "Yanmar-style OEM track design" },
  es: { vrt: "oruga de goma VANROCK", width: "ancho (mm)", pitch: "paso (mm)", links: "número de eslabones", narrow: "variante de guía estrecha", wide: "variante de guía ancha", variant: "variante de diseño", bobcat: "diseño OEM tipo Bobcat", yanmar: "diseño OEM tipo Yanmar" },
  it: { vrt: "cingolo in gomma VANROCK", width: "larghezza (mm)", pitch: "passo (mm)", links: "numero di maglie", narrow: "variante guida stretta", wide: "variante guida larga", variant: "variante di design", bobcat: "design OEM tipo Bobcat", yanmar: "design OEM tipo Yanmar" },
  de: { vrt: "VANROCK Gummikette", width: "Breite (mm)", pitch: "Teilung (mm)", links: "Stegzahl", narrow: "schmale Führungsvariante", wide: "breite Führungsvariante", variant: "Designvariante", bobcat: "OEM-Design Bobcat-Typ", yanmar: "OEM-Design Yanmar-Typ" },
  pt: { vrt: "esteira de borracha VANROCK", width: "largura (mm)", pitch: "passo (mm)", links: "número de elos", narrow: "variante de guia estreita", wide: "variante de guia larga", variant: "variante de design", bobcat: "design OEM tipo Bobcat", yanmar: "design OEM tipo Yanmar" },
  fr: { vrt: "chenille caoutchouc VANROCK", width: "largeur (mm)", pitch: "pas (mm)", links: "nombre de maillons", narrow: "variante à guide étroit", wide: "variante à guide large", variant: "variante de conception", bobcat: "conception de chenille OEM type Bobcat", yanmar: "conception de chenille OEM type Yanmar" },
  nl: { vrt: "VANROCK rubbertrack", width: "breedte (mm)", pitch: "steek (mm)", links: "aantal schakels", narrow: "smalle geleidingsvariant", wide: "brede geleidingsvariant", variant: "ontwerpvariant", bobcat: "Bobcat-stijl OEM-rupsontwerp", yanmar: "Yanmar-stijl OEM-rupsontwerp" },
  ru: { vrt: "резиновая гусеница VANROCK", width: "ширина (mm)", pitch: "шаг (mm)", links: "количество звеньев", narrow: "вариант с узкой направляющей", wide: "вариант с широкой направляющей", variant: "вариант конструкции", bobcat: "конструкция OEM-гусеницы типа Bobcat", yanmar: "конструкция OEM-гусеницы типа Yanmar" },
  lt: { vrt: "VANROCK guminis vikšras", width: "plotis (mm)", pitch: "žingsnis (mm)", links: "grandžių skaičius", narrow: "siauro kreiptuvo variantas", wide: "plataus kreiptuvo variantas", variant: "konstrukcijos variantas", bobcat: "Bobcat tipo OEM vikšro konstrukcija", yanmar: "Yanmar tipo OEM vikšro konstrukcija" },
};

const parseVrt = (code) => {
  const m = String(code || "").trim().match(/^VRT([A-Z]?)([\d.,]+)[Xx]([\d.,]+)([A-Z]*)[Xx](\d+)([A-Z/]*)$/i);
  if (!m) return null;
  return {
    prefix: m[1].toUpperCase(),
    width: m[2].replace(",", "."),
    pitch: m[3].replace(",", "."),
    pitchSuffix: m[4].toUpperCase(),
    links: m[5],
    suffix: m[6].toUpperCase(),
  };
};

const suffixLabel = (s, t) => {
  if (s.includes("N")) return t.narrow;
  if (s.includes("W")) return t.wide;
  return t.variant;
};

export const PartCodeDecoder = ({ code }) => {
  const t = T[CUR_LANG] || T.en;
  const p = parseVrt(code);
  if (!p) return null;
  const rows = [["VRT", t.vrt]];
  if (p.prefix === "B") rows.push([`B${p.width}`, `${t.width} — ${t.bobcat}`]);
  else if (p.prefix === "Y") rows.push([`Y${p.width}`, `${t.width} — ${t.yanmar}`]);
  else rows.push([p.width, t.width]);
  rows.push([p.pitch + (p.pitchSuffix || ""), p.pitchSuffix ? `${t.pitch} — ${suffixLabel(p.pitchSuffix, t)}` : t.pitch]);
  rows.push([p.links, t.links]);
  if (p.suffix) rows.push([p.suffix, suffixLabel(p.suffix, t)]);
  return (
    <div className="mt-3 space-y-1" data-testid="part-code-decoder">
      {rows.map(([k, v]) => (
        <div key={k} className="flex items-baseline gap-2 text-[11px] leading-snug">
          <span className="font-mono-tech font-bold text-gray-950 shrink-0">{k}</span>
          <span className="text-gray-400">→</span>
          <span className="text-gray-500">{v}</span>
        </div>
      ))}
    </div>
  );
};
